export default "__VITE_ASSET__DUTE1PU3__"